var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.2C16.933 9.2 18.5 7.58822 18.5 5.6C18.5 3.61177 16.933 2 15 2C13.7896 2 12.7228 2.63194 12.0943 3.59254C13.261 4.53321 14 5.99048 14 7.6C14 8.0791 13.9345 8.54472 13.8118 8.98723C14.1828 9.12494 14.5829 9.2 15 9.2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8525 19.9471C16.8901 18.5007 17.5 16.7175 17.5 14.8C17.5 13.0176 16.0845 11.5 14.25 11.5H12.2231C12.4023 11.3454 12.5705 11.1783 12.7265 11H20.25C21.2165 11 22 11.8059 22 12.8C22 16.4796 19.3164 19.5145 15.8525 19.9471Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.2C10.933 11.2 12.5 9.58822 12.5 7.6C12.5 5.61177 10.933 4 9 4C7.067 4 5.5 5.61177 5.5 7.6C5.5 9.58822 7.067 11.2 9 11.2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13H14.25C15.2165 13 16 13.8059 16 14.8C16 18.7764 12.866 22 9 22C5.13401 22 2 18.7764 2 14.8C2 13.8059 2.7835 13 3.75 13ZM9.75 14.5C9.75 14.0858 9.41421 13.75 9 13.75C8.58579 13.75 8.25 14.0858 8.25 14.5V16.25H6.5C6.08579 16.25 5.75 16.5858 5.75 17C5.75 17.4142 6.08579 17.75 6.5 17.75H8.25V19.5C8.25 19.9142 8.58579 20.25 9 20.25C9.41421 20.25 9.75 19.9142 9.75 19.5V17.75H11.5C11.9142 17.75 12.25 17.4142 12.25 17C12.25 16.5858 11.9142 16.25 11.5 16.25H9.75V14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGroup);
export default __webpack_public_path__ + "static/media/add-group.4bb645fcb670c507ba61fc6b4286df04.svg";
export { ForwardRef as ReactComponent };